import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import WebRTCClassRoom from "./WebRTCClassRoom";
import { normalizeRole, ROLE_TEACHER } from "../utils/authRole";

export default function ClassroomMeetingPage({ userRole }) {
  const { roomCode } = useParams();
  const navigate = useNavigate();
  const isTeacher = normalizeRole(userRole) === ROLE_TEACHER;
  const classroomRole = isTeacher ? "teacher" : "student";
  const rawName = localStorage.getItem("currentUserName") || (isTeacher ? "Teacher" : "Student");
  const displayName = rawName.includes("@")
    ? rawName.split("@")[0].replace(/[._-]+/g, " ")
    : rawName;

  return (
    <main className="min-h-screen bg-slate-950 p-3 text-white sm:p-6">
      <div className="mx-auto max-w-7xl">
        <div className="mb-4">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-300">Live classroom</p>
          <h1 className="mt-1 text-xl font-semibold">Room {roomCode}</h1>
        </div>
        <WebRTCClassRoom
          roomId={roomCode}
          role={classroomRole}
          displayName={displayName}
          onClose={() => navigate(isTeacher ? "/teacher-dashboard" : "/user-dashboard")}
        />
      </div>
    </main>
  );
}
